module.exports = __webpack_public_path__ + "static/media/john_t.a34a392e.jpg";